import React from "react";
import contactUs from "../../PicesForPages/ContactUs.jpg";
import ContactForm from "../Form/ContactForm";

function ContactUs() {
  return (
    <div className="purchaseParent">
      <div className="purchasetopParent ContactUsPageTopParent">
        <img
          fetchPriority="high"
          loading="eager"
          src={contactUs}
          alt="contactUsImage"
          className="background-video contactUsImage"
        />
        <div className="purchasetopBox ContactUsPageTopBox">
          {/* The existing Purchase span */}
          <span>Contact Us</span>
        </div>
      </div>
      <div className="purchaseBottomParent">
        <div className="purchaseBottomBox">
          <div className="purchaseBottomLeftBox contactUsBottomLeftBox">
            <span className="purchaseBottomLeftHeader">Get In Touch</span>
            <a
              href="tel:+1-(614) 397-1676"
              style={{ textDecoration: "none" }}
              className="purchaseBottomLeftContent contactUsBottomLeftContent"
            >
              <span>Phone: </span>
              <span>(614) 397-1676</span>
            </a>
            <a
              href="mailto: contact@vidhimortgage.com"
              style={{ textDecoration: "none" }}
              className="purchaseBottomLeftContent contactUsBottomLeftContent"
            >
              <span>Email: </span>
              <span>contact@vidhimortgage.com</span>
            </a>
            <a
              href="https://www.google.com/maps?q=#!"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", textAlign: "end" }}
              className="purchaseBottomLeftContent contactUsBottomLeftContent"
            >
              <span>Address: </span>
              <span>5714 Dorrington St, Lewis Center OH 43035</span>
            </a>
          </div>
          <ContactForm />
        </div>
      </div>
    </div>
  );
}

export default ContactUs;
